import { RegistryRoute } from '#/types/RegistryRoute';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import RouteRegistry from '../store/RouteRegistry';

export const useActiveRoute = (): RegistryRoute | undefined => {
    const { pathname } = useLocation();
    return useMemo(() => RouteRegistry.getRouteByPath(pathname), [pathname]);
};
